import React, { useEffect, FC, memo, useState } from "react";
import Slider, { LazyLoadTypes } from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
  CarouselThumbnailHero,
  ThumbnailSliderWrap,
  ZoomSliderImage,
} from "../style";
import {
  Box,
  Center,
  Image,
  IconButton,
  useBreakpointValue,
} from "@chakra-ui/react";
import useCarousel from "../hooks/useCarousel";
import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";
import { If, Then } from "react-if";

interface IProps {
  slide: string[];
  thumbnails: string[];
  zoom: string[];
}
const CarouselThumbnail: FC<IProps> = ({ slide, thumbnails }) => {
  const [activeSlide, setActiveSlide] = useState(0);
  const {
    nav1,
    nav2,
    slider1,
    slider2,
    setNav1,
    setNav2,
    setSlider1,
    setSlider2,
  } = useCarousel();

  useEffect(() => {
    if (slider1) {
      setNav1(slider1);
    }
    if (slider2) {
      setNav2(slider2);
    }
  }, [slider1, slider2]);

  const settingsMain = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: ".slider-nav",
    lazyLoad: "progressive" as LazyLoadTypes | undefined,
  };

  const settingsThumbs = {
    slidesToShow: thumbnails.length,
    slidesToScroll: 1,
    asNavFor: ".slider-for",
    dots: true,
    centerMode: true,
    swipeToSlide: true,
    focusOnSelect: true,
    centerPadding: "10px",
    lazyLoad: "progressive" as LazyLoadTypes | undefined,
    beforeChange: (_current: number, next: number) => setActiveSlide(next),
  };

  const top = useBreakpointValue({ base: "50%", md: "50%" });

  return (
    <CarouselThumbnailHero>
      <ZoomSliderImage>
        <Box position={"relative"} width={"full"} overflow={"hidden"}>
          {/* Left Icon */}
          <IconButton
            borderWidth={0}
            borderColor={"transparent"}
            aria-label="left-arrow"
            variant="ghost"
            position="absolute"
            left={{ base: 0, md: "-5%", lg: 0 }}
            top={top}
            transform={"translate(0%, -50%)"}
            zIndex={2}
            onClick={() => slider1?.slickPrev()}
            display={{ base: "block", lg: "none" }}
          >
            <ChevronLeftIcon boxSize={14} color={"grey200"} />
          </IconButton>
          {/* Right Icon */}
          <IconButton
            borderWidth={0}
            borderColor={"transparent"}
            aria-label="right-arrow"
            variant="ghost"
            position="absolute"
            right={{ base: 0, md: "-5%", lg: 0 }}
            top={top}
            transform={"translate(0%, -50%)"}
            zIndex={2}
            onClick={() => slider1?.slickNext()}
            display={{ base: "block", lg: "none" }}
          >
            <ChevronRightIcon boxSize={14} color={"grey200"} />
          </IconButton>
          <Slider
            {...settingsMain}
            asNavFor={nav2}
            ref={(slider) => setSlider1(slider)}
          >
            {slide?.map((item, index) => (
              <div className="slick-slide" key={index}>
                <Box
                  width={{ base: "80%", md: "85%", lg: "full" }}
                  margin={"auto"}
                  overflow={"hidden"}
                  h={{ base: "16rem", lg: "auto" }}
                >
                  <Image
                    className="slick-slide-image"
                    src={item}
                    alt="commdevices"
                    width={"full"}
                    height={"auto"}
                    loading="lazy"
                    objectFit="contain"
                  />
                </Box>
              </div>
            ))}
          </Slider>
        </Box>
      </ZoomSliderImage>

      <ThumbnailSliderWrap>
        <Box
          display={{ base: "none", lg: "block" }}
          position={"relative"}
          width={"full"}
          overflow={"hidden"}
        >
          <If condition={thumbnails?.length > 3}>
            <Then>
              <IconButton
                borderWidth={0}
                borderColor={"transparent"}
                aria-label="left-arrow"
                variant="ghost"
                position="absolute"
                left={"-2%"}
                top={"45%"}
                transform={"translate(0%, -50%)"}
                zIndex={2}
                onClick={() => slider2?.slickPrev()}
                display={{ base: "none", lg: "block" }}
              >
                <ChevronLeftIcon boxSize={10} color={"grey200"} />
              </IconButton>
              {/* Right Icon */}
              <IconButton
                borderWidth={0}
                borderColor={"transparent"}
                aria-label="right-arrow"
                variant="ghost"
                position="absolute"
                right={"-2%"}
                top={"45%"}
                transform={"translate(0%, -50%)"}
                zIndex={2}
                onClick={() => slider2?.slickNext()}
                display={{ base: "none", lg: "block" }}
              >
                <ChevronRightIcon boxSize={10} color={"grey200"} />
              </IconButton>
            </Then>
          </If>
          <Slider
            {...settingsThumbs}
            asNavFor={nav1}
            ref={(slider) => setSlider2(slider)}
          >
            {thumbnails?.map((item, index) => (
              <div className="slick-thumbnail-slide" key={index}>
                <Center
                  p={1}
                  border={"1px solid #d8d8d8"}
                  borderRadius={"4px"}
                  // width={"100px"}
                  height={"80px"}
                  bg={"white50"}
                  className={activeSlide === index ? "active-thumbnail" : ""}
                  overflow={"hidden"}
                >
                  <Image
                    className="slick-slide-image"
                    src={item}
                    alt="commdevices"
                    objectFit="contain"
                    borderRadius={"4px"}
                    loading="lazy"
                  />
                </Center>
              </div>
            ))}
          </Slider>
        </Box>
      </ThumbnailSliderWrap>
    </CarouselThumbnailHero>
  );
};

export default memo(CarouselThumbnail);
